<footer class="footer flex flex-col gap-4 mx-auto text-sm leading-[22px] text-Gray-800 max-w-[1400px] px-8 pb-6 pt-[70px]">
    <div class="flex flex-col md:flex-row justify-between items-start gap-4 border border-l-0 border-r-0 border-b-0 border-Gray-400 pt-6">
        <a href="https://avanacuso.com/" target="_blank">
            <img [src]="sanitizedLogoSource" width="85">
        </a>
        <div class="flex flex-col md:flex-row gap-4 md:gap-2">
            <div class="flex items-center gap-2 md:mr-4">
                <i class="pi pi-map-marker"></i>
                16150 N Arrowhead Fountains Center Dr., Suite 243, Peoria, AZ 85382
            </div>
            <div class="flex items-center gap-2">
                <i class="pi pi-phone"></i>
                <a href="tel:8008948328" class="hover:text-gray-400 transition-colors no-underline">800.894.8328</a>
            </div>
        </div>
    </div>
    <div class="flex flex-col md:flex-row justify-between items-start md:items-center gap-4">
        <div class="no-underline">
            <span class="mr-4">Copyright © {{currentYear}} AVANACUSO.com </span>| <a
            href="https://avanacuso.com/privacy-policy/" target="_blank" class="ml-4 hover:text-gray-400 transition-colors">Privacy Policy</a></div>
        <div class="flex flex-col md:flex-row items-start md:items-center gap-2">
            <a href="https://avanacompanies.com/" class="mr-4 hover:text-gray-400 transition-colors no-underline" target="_blank">
                A Member of the AVANA Companies Family
            </a>
            <a href="https://avanacompanies.com/" target="_blank" class="mt-2 md:mt-0">
                <img width="150" [src]="sanitizeAvanaLogoSource">
            </a>
        </div>
    </div>
</footer>